// Generated by ReScript, PLEASE EDIT WITH CARE


var frenchLaw = (require("./french_law.js"));

var resetLog = (function() {
    return frenchLaw.eventsManager.resetLog(0);
  });

var retrieveRawEventsSerialized = (function() {
    return frenchLaw.eventsManager.retrieveRawEvents(0);
  });

var retrieveEventsSerialized = (function() {
    return frenchLaw.eventsManager.retrieveEvents(0);
  });

var computeAllocationsFamiliales = (function(input) {
    frenchLaw.eventsManager.resetLog(0);
    return frenchLaw.computeAllocationsFamiliales(input);
  });

var computeAidesAuLogement = (function(input) {
    frenchLaw.eventsManager.resetLog(0);
    return frenchLaw.computeAidesAuLogement(input);
  });

export {
  resetLog ,
  retrieveRawEventsSerialized ,
  retrieveEventsSerialized ,
  frenchLaw ,
  computeAllocationsFamiliales ,
  computeAidesAuLogement ,
}
/* frenchLaw Not a pure module */
